<template>
  <div>
    <forget-password></forget-password>
  </div>
</template>

<script>
import ForgetPassword from '@/components/common/ForgetPassword'

export default {
  components: {
    ForgetPassword,
  },
  data() {
    return {}
  },
  computed: {},
  methods: {},
}
</script>

<style lang="stylus" scoped>
</style>
